import React, { useState, useEffect, useRef } from "react";
import styles from "./find_user_or_firm.module.css";
import { useSelector, useDispatch } from "react-redux";
import { checkInput } from "../../utils/util_functions";
import { EDIT_LAST_NAME_FIND_USER } from "../../services/actions/find_user_actions";
import { getCustomer } from "../../services/selectors";
import { getCookie } from "../../utils/cookie";
import { getUsers } from "../../utils/api";
import { SET_CUSTOMER } from "../../services/actions/customer_actions";
import { getFirmsThunk } from "../../services/actions/firms_actions";
import { USER_ROLES } from "../../utils/constants";


const FindUser = ({ showUsersList, setShowUsersList, labelText = null  }) => {

  let accessToken = getCookie('accessToken') || '';
  let refreshToken = getCookie('refreshToken') || '';

  const [statusLastName, setStatusLastName] = useState({ valid: false });
  const [users, setUsers] = useState([]);

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const customer = useSelector(getCustomer);

  useEffect(() => {
    dispatch({ type: EDIT_LAST_NAME_FIND_USER, last_name: '' });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    inputRef.current.value = `${customer.last_name} ${customer.first_name} ${customer.surname}`;
  }, [customer]);

  const changeLastName = (e) => {
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusLastName({ ...statusLastName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_LAST_NAME_FIND_USER, last_name: e.target.value });

    if (currStatus.valid) {
      getUsers(accessToken, refreshToken, e.target.value)
        .then(res => {
          setShowUsersList(true);
          setUsers([...res]);
        })
        .catch(err => {
          console.log(err);
        });

    } else {
      setShowUsersList(false);
    }
    inputRef.current.focus();
  }

  const clickInputLastName = () => {
    if (users.length > 0) {
      // setShowUsersList(true);
      setShowUsersList(!showUsersList);
    }
  }

  const handleClick = (user) => {
    dispatch({ type: SET_CUSTOMER, customer: user });
    dispatch(getFirmsThunk(accessToken, refreshToken, user.id));
    setShowUsersList(false);
    dispatch({ type: EDIT_LAST_NAME_FIND_USER, last_name: user.last_name });
    inputRef.current.value = `${customer.last_name} ${customer.first_name} ${customer.surname}`;

  }


  return (
    <div className={styles.container}>
      <label htmlFor="last_name" className="label_text">
        {labelText}&nbsp;
        <input
          type="text"
          id="last_name" name="last_name"
          required={true}
          onChange={changeLastName}
          className="input"
          ref={inputRef}
          onClick={clickInputLastName}
          placeholder="Поиск по фамилии"
        />
        <p className={`error`}>{statusLastName?.text}</p>
      </label>
      {showUsersList && users.length > 0 &&
        <ul className={styles.list} id='list_users'>
          {users.map(user => {
            return (
              <li className={styles.item} key={user.id} onClick={() => handleClick(user)}>
                {user.last_name} {user.first_name} {user.surname} {user.email}
                {user.role !== USER_ROLES.customer && ` (${user.role})`}
              </li>
            );
          })}
        </ul>
      }
    </div>
  )
}

export default FindUser;
